import { ShowcaseConstants } from './showcase.constants';
import { SetShowcaseStatusState, ShowcaseStatus } from './showcase.model';

export const setShowcaseStatus = (
  status: ShowcaseStatus
): SetShowcaseStatusState => ({
  type: ShowcaseConstants.SET_SHOWCASE_STATUS,
  status,
});
